import React, {useEffect, useState} from "react";
// import { AddTagsToAsset } from "../campaigns/campaign/components/AddTagsToAsset"

import {selectBulkEditArray} from "../../redux/bulk-edit/bulkEdit.selectors";
import {useSelector} from "react-redux";
import {
  selectFiltredAssets,
  selectSubFiltredAssets,
} from "../../redux/filter/filter.selectors";

import {useDispatch} from "react-redux";
import {BulkEditReset, SelectAll} from "../../redux/bulk-edit/bulkEdit.actions";

import * as S from "../../components/bulk-edit/styles";
import ReelerBadge from "../../components/commons/ReelerBadge";

const BulkEditDeletedAssets = () => {
  const dispatch = useDispatch();
  const assetArray = useSelector(selectBulkEditArray);
  const filtredAssets = useSelector(selectFiltredAssets);
  const subFiltredAssets = useSelector(selectSubFiltredAssets);

  const ShowSelectAll = () => {
    const handleSelectAll = () => {
      if (subFiltredAssets?.length > 0) {
        dispatch(SelectAll(subFiltredAssets));
      } else {
        dispatch(SelectAll(filtredAssets));
      }
    };

    if (filtredAssets?.length > 0 || subFiltredAssets?.length > 0) {
      return <span onClick={() => handleSelectAll()}>Select all</span>;
    }

    return null;
  };

  return (
    <>
      <S.BulkEditContainer
        $positionFixed={false}
        $active={assetArray?.length > 0}
      >
        <div className="d-flex flex-row align-items-center">
          <S.BulkEditItem>Bulk edit</S.BulkEditItem>
          <S.BulkEditItem>
            <ReelerBadge value={assetArray.length} />
          </S.BulkEditItem>
        </div>

        <S.BulkEditItem>
          <ShowSelectAll />
        </S.BulkEditItem>
        <S.BulkEditItem>
          <span onClick={() => dispatch(BulkEditReset())}>Uncheck all</span>
        </S.BulkEditItem>
      </S.BulkEditContainer>
    </>
  );
};
export default BulkEditDeletedAssets;
